import { parsePhoneNumber } from 'libphonenumber-js'

export const formatPhoneNumber = (phoneNumber: string): string => {
  try {
    const parsed = parsePhoneNumber(phoneNumber, 'SE')
    return parsed.formatNational()
  } catch {
    return phoneNumber
  }
}

export const normalizeExpiryDate = (expiryDate: string | number): number => {
  // If already a number (timestamp), return as is
  if (typeof expiryDate === 'number') {
    return expiryDate;
  }

  // Handle string format: "2025-03-30 16:39:53"
  try {
    const [datePart, timePart] = expiryDate.split(' ');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);

    // Create date with explicit components (months are 0-indexed in JS)
    const date = new Date(year, month - 1, day, hours, minutes, seconds);

    // Return as timestamp
    return date.getTime();
  } catch (e) {
    console.error('Error parsing expiry date:', e);
    // Return current time as fallback (or could return 0 depending on your error handling needs)
    return Date.now();
  }
}
